import styled from "styled-components"

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  --swiper-pagination-color: #24AF61;
`;
